// Show Variant wise badge on Image Gallery
document.addEventListener('variant:change', function(event) {
  const variant = event.detail.variant;
  const variantId = variant.id;
  const js_variant_based_sales = document.querySelectorAll('.js_variant_based_sale');
  if(js_variant_based_sales.length > 0){
    js_variant_based_sales.forEach(wrapper=>{
      const allVariantSaleBadges = wrapper.querySelectorAll('.js_variantsale__badge');
      if(allVariantSaleBadges.length > 0){
        allVariantSaleBadges.forEach(variant_sale=>{
          const badgeVariantId = Number(variant_sale.getAttribute('data-variant-id'));
          if(badgeVariantId === variantId){
            variant_sale.removeAttribute('hidden');
          } else{
            variant_sale.setAttribute('hidden', true);
          }
        })
      }
    })
  }
})



document.addEventListener("DOMContentLoaded", function(event) {
    const shippingEls = document.querySelectorAll('.shipping-el');

    shippingEls.forEach(shippingel => {
      console.log('shippingel', getComputedStyle(shippingel).color);
      if (getComputedStyle(shippingel).color === "rgb(255, 0, 0)") {
        // Look for the closest <product-form> element within the same parent container
        const closestProductForm = shippingel.closest('.product-info-inner')?.querySelector('product-form');
        
        // If a <product-form> was found, hide it
        if (closestProductForm) {
          closestProductForm.style.display = 'none';
        }
      }
    });
});

document.addEventListener('variant:change', function(event) {
  console.log(event);
  const variant = event.detail.variant;
  console.log(variant);
  renderAvailability(variant);
  renderAdditionalInformation(variant);
  toggleCountdownBox(variant);
});

const renderAvailability = (variant) => {
  if(typeof variantMetafields !== 'undefined' && variantMetafields !== null){
     const metafieldValue = variantMetafields[variant.id];
    if (metafieldValue) {
      console.log('Metafield Value:', metafieldValue);
      // Use the metafield value as needed
      document.querySelector('.shipping-el').innerHTML = metafieldValue.label;
      document.querySelector('.shipping-el').style.color = metafieldValue.color;
      document.querySelector('.shipping-el').classList.remove('available_product');
      if(metafieldValue.color == "#ff0000"){
        document.querySelector('product-form').style.display = 'none';
      }else{
        document.querySelector('product-form').style.display = 'block';
      }
    } else {
      console.log('Metafield not found for this variant.');
      document.querySelector('.shipping-el').classList.add('available_product');
      document.querySelector('.shipping-el').innerHTML = '';
      document.querySelector('.shipping-el').style.color = '';
      document.querySelector('product-form').style.display = 'block';
    } 
  }else{
      if(window["variantMetafields" + variant.featured_image.product_id]){
        const metafieldValue = window["variantMetafields" + variant.featured_image.product_id][variant.id];
        if (metafieldValue) {
          console.log('Metafield Value:', metafieldValue);
          document.querySelector('.shipping-el').classList.remove('available_product');
          // Use the metafield value as needed
          event.srcElement.closest(".product-info-inner").querySelector('.shipping-el').innerHTML = metafieldValue.label;
          event.srcElement.closest(".product-info-inner").querySelector('.shipping-el').style.color = metafieldValue.color;
        } else {
          console.log('Metafield not found for this variant.');
          document.querySelector('.shipping-el').classList.add('available_product');
          document.querySelector('.shipping-el').innerHTML = '';
          document.querySelector('.shipping-el').style.color = '';
          document.querySelector('product-form').style.display = 'block';
        } 
      }
  }

  const shippingEls = document.querySelectorAll('.shipping-el');

    shippingEls.forEach(shippingel => {
      console.log('shippingel', getComputedStyle(shippingel).color);
      if (getComputedStyle(shippingel).color === "rgb(255, 0, 0)") {
        // Look for the closest <product-form> element within the same parent container
        const closestProductForm = shippingel.closest('.product-info-inner')?.querySelector('product-form');
        
        // If a <product-form> was found, hide it
        if (closestProductForm) {
          closestProductForm.style.display = 'none';
        }
      }else{
        // Look for the closest <product-form> element within the same parent container
        const closestProductForm = shippingel.closest('.product-info-inner')?.querySelector('product-form');
        
        // If a <product-form> was found, hide it
        if (closestProductForm) {
          closestProductForm.style.display = 'block';
        }
      }
    });
};

const renderAdditionalInformation = (variant) => {
  if(typeof allFrontendMetafields !== 'undefined' && allFrontendMetafields !== null){
    console.log('allFrontendMetafields', allFrontendMetafields);
    const element = document.querySelector('.additional_information');
    const escapedHTML = allFrontendMetafields[variant.id]?.additional_information;
    if(escapedHTML){
      const parser = new DOMParser();
      const parsedDoc = parser.parseFromString(escapedHTML, 'text/html');
      const realHTML = parsedDoc.body.textContent;
      if(element){
        element.innerHTML = realHTML; 
        element.style.display = "flex";
      }
    }else{
      if(element)
        element.style.display = "none";
    }
  }
};

const toggleCountdownBox = (variant) => {
  if(typeof variantMetafields !== 'undefined' && variantMetafields !== null){
    const metafieldValue = variantMetafields[variant.id]?.label ?  variantMetafields[variant.id]?.label : "";
    if (!variant.available) {
      const countdownBoxes = document.querySelectorAll('[data-hidesoldout="true"]'); // Select all matching elements
      countdownBoxes.forEach(box => {
        box.style.display = 'none'; // Hide each box
      });
    } else if (!metafieldValue.includes('in 1-3 Werktagen bei dir')){
        const countdownBoxes = document.querySelectorAll('[data-hidesoldout="true"]');
        countdownBoxes.forEach(box => {
          box.style.display = 'none'; // Hide each box
        });
    } else {
      const countdownBoxes = document.querySelectorAll('[data-hidesoldout="true"]'); // Select all matching elements
      countdownBoxes.forEach(box => {
        box.style.display = ''; // Reset the display style to show them (default behavior)
      });
    }
  }
};

const current_json_t = document.querySelector('meta[name="taggrs-current"]').content;
const current_t = JSON.parse(current_json_t);
document.addEventListener('DOMContentLoaded', toggleCountdownBox(current_t));


window.closeIcon = function (element){
  if(element != document){
      const closestModal = element.closest('quick-add-modal');
      if (closestModal) {
        const iconClose = closestModal.querySelector('[data-button-close]');
        if (iconClose) {
          iconClose.addEventListener('click', () => {
            document.body.click();
          });
        }
      }
    }
}

window.initSlider = function (element, defaultOpened) {
  if(!element){
    element = document;
  }
  // console.log('element', element);
  const model_opener_selectors = document.querySelectorAll('.js-size_chart_open, .color-variant-selector-btn');
  if(model_opener_selectors.length > 0){
    model_opener_selectors.forEach(opener=>{
      opener.addEventListener('click', ()=>{
        showColorSelector();
      });
  });
  }
  document.addEventListener('click', function(event) {
    if (!element.contains(event.target)) {
      hideColorSelector();
    }
  });
  
  const showColorSelector = () => {
        // console.log(element);
        let bg = element.querySelector(".image-color-variant-slider-bg");
        bg.style.pointerEvents = "inherit";
        let slider = element.querySelector(".image-color-variant-slider");
  
        bg.classList.add('visible-slider-bg');
        slider.classList.add('visible-slider');
      }
  
      const hideColorSelector = () => {
        let bg = element.querySelector(".image-color-variant-slider-bg");
        bg.style.pointerEvents = "none";
        let slider = element.querySelector(".image-color-variant-slider");
  
        bg.classList.remove('visible-slider-bg');
        slider.classList.remove('visible-slider');
        // element = '';
        setTimeout(() => {
          // console.log(defaultOpened);
          // if(!defaultOpened){
          //   bg.remove();
          //   slider.remove();
          // }
          // console.log(document.body.classList.contains('no-scroll'));
          if (!document.body.classList.contains('no-scroll')) {
            // console.log(defaultOpened);
            if(!defaultOpened){
              bg.remove();
              slider.remove();
            }
            element = document;
          }
        }, 500);
        // element = document;
      }
  
      window.selectColor = (optionValue) => {
        element.querySelector(`label[title="${optionValue}"]`).click();
        hideColorSelector();
      }
  
      const showInfoForSlide = (index) => {
        element.querySelectorAll(`.price-name-button-wrapper`).forEach(item=> {
          item.style.display = 'none';
        })
        element.querySelector(`.price-name-button-wrapper[data-index="${index+1}"]`).style.display = 'block';
      };
  
      const addThumbBtnsClickHandlers = (emblaApiMain, emblaApiThumb) => {
        const slidesThumbs = emblaApiThumb.slideNodes()
  
        const scrollToIndex = slidesThumbs.map(
          (_, index) => () => emblaApiMain.scrollTo(index)
        )
  
        slidesThumbs.forEach((slideNode, index) => {
          slideNode.addEventListener('click', scrollToIndex[index], false);
        })
  
        return () => {
          slidesThumbs.forEach((slideNode, index) => {
            slideNode.removeEventListener('click', scrollToIndex[index], false)
          })
        }
      }
  
      const addToggleThumbBtnsActive = (emblaApiMain, emblaApiThumb) => {
      const slidesThumbs = emblaApiThumb.slideNodes()
  
      const toggleThumbBtnsState = () => {
        emblaApiThumb.scrollTo(emblaApiMain.selectedScrollSnap())
        const previous = emblaApiMain.previousScrollSnap()
        const selected = emblaApiMain.selectedScrollSnap()
        slidesThumbs[previous].classList.remove('embla-thumbs__slide--selected')
        slidesThumbs[selected].classList.add('embla-thumbs__slide--selected')
      }
  
      emblaApiMain.on('select', toggleThumbBtnsState)
      emblaApiThumb.on('init', toggleThumbBtnsState)
  
      return () => {
        const selected = emblaApiMain.selectedScrollSnap()
        slidesThumbs[selected].classList.remove('embla-thumbs__slide--selected')
      }
    }
  
        const OPTIONS = {containScroll: false}
        const OPTIONS_THUMBS = {
          containScroll: 'keepSnaps',
          dragFree: true
        }
  
        const viewportNodeMainCarousel = element.querySelector('.embla__viewport')
        const viewportNodeThumbCarousel = element.querySelector(
          '.embla-thumbs__viewport'
        )
        const emblaApiMain = EmblaCarousel(viewportNodeMainCarousel, OPTIONS)
        const emblaApiThumb = EmblaCarousel(viewportNodeThumbCarousel, OPTIONS_THUMBS)
  
        const removeThumbBtnsClickHandlers = addThumbBtnsClickHandlers(
          emblaApiMain,
          emblaApiThumb
        )
        const removeToggleThumbBtnsActive = addToggleThumbBtnsActive(
          emblaApiMain,
          emblaApiThumb
        )
  
        emblaApiMain
          .on('destroy', removeThumbBtnsClickHandlers)
          .on('destroy', removeToggleThumbBtnsActive)
  
        emblaApiThumb
          .on('destroy', removeThumbBtnsClickHandlers)
          .on('destroy', removeToggleThumbBtnsActive)
  
        const bg = document.querySelector(".image-color-variant-slider-bg");
        const slider = document.querySelector(".image-color-variant-slider");
  
        document.querySelector(".image-color-variant-slider-bg").remove();
        document.querySelector(".image-color-variant-slider").remove();
  
        if(defaultOpened){
          document.body.append(bg);
          document.body.append(slider);
        }
        else{
          element.append(bg);
          element.append(slider);
        }
  
        element.querySelector(".image-color-variant-slider-bg").addEventListener("click", ()=>{console.log('clicked');hideColorSelector()});
  
        element.querySelector('.next-button').addEventListener('click',()=>{
          emblaApiMain.scrollNext();
        });
  
        element.querySelector('.prev-button').addEventListener('click',()=>{
          emblaApiMain.scrollPrev();
        });
  
        emblaApiMain.on('select', () => {
          const activeIndex = emblaApiMain.selectedScrollSnap();
          showInfoForSlide(activeIndex)
        });
}
document.addEventListener('DOMContentLoaded', function() {
  window.initSlider('', true);
});

window.updateDeliveryMessage = function (input){
  const input_id = Number(input.getAttribute('data-variant-id'));
  const closestParent = input.closest('.product-card');
  if(closestParent){
    const deliverMessageElement = closestParent.querySelector('.card-delivery-time-message');
    const selected_variant_data = closestParent.querySelector('.card-product-variant-metafields');
    if(!selected_variant_data) return;
    const JsonData = JSON.parse(selected_variant_data.textContent);
    const selected_variant_metafield_data = JsonData["cardProductMetafields"][input_id];
    if(!selected_variant_metafield_data || selected_variant_metafield_data.label == null || selected_variant_metafield_data.color == null){
      deliverMessageElement.innerHTML = '';
    } else{
      if(deliverMessageElement){
        deliverMessageElement.innerHTML = selected_variant_metafield_data.label;
        deliverMessageElement.style.color = selected_variant_metafield_data.color;
      }
    }
  }
}